import { render, staticRenderFns } from "./ArticlesCard.vue?vue&type=template&id=0952b244&scoped=true"
import script from "./ArticlesCard.vue?vue&type=script&lang=ts"
export * from "./ArticlesCard.vue?vue&type=script&lang=ts"
import style0 from "./ArticlesCard.vue?vue&type=style&index=0&id=0952b244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0952b244",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvoiIcon: require('/usr/src/app/components/SvoiUI/SvoiIcon.vue').default})
